import { Carer, Responsibility } from '@lmc/ts-common'
import { useSelector } from 'react-redux'

const useSafeguardingAccess = (): boolean | undefined => {
  const permissions = useSelector(
    (state: { global: { user: Carer } }) => state.global.user?.permissions
  )

  return permissions?.some(
    (permission) => permission === Responsibility.SafeguardingOfficer
  )
}

export default useSafeguardingAccess
